module.exports = __webpack_public_path__ + "img/28.b16b4127.png";